/**
 * Calculate tax total on taxable expenses.
 *
 * @param expenses  - array of expenses with taxable flag, cost, and quantity
 * @param taxRate   - tax rate as a percentage (e.g. 8.25 means 8.25%)
 * @returns tax amount (always >= 0)
 */
export function calculateTaxTotal(
    expenses: Array<{ taxable?: boolean; cost: number; quantity: number }>,
    taxRate: number,
): number {
    if (taxRate <= 0) return 0;
    return expenses
        .filter(e => e.taxable)
        .reduce((sum, e) => sum + Math.round(e.cost * e.quantity * taxRate) / 100, 0);
}

export default calculateTaxTotal;
